import { css } from "styled-components";
import { BladeContent } from "../../../../components/BladeContent";
import { BladeHeaderSupertitle } from "../../../../components/BladeHeader";
import { CTA } from "../../../../components/CTA";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
import { Backdrop } from "../../../../components/Backdrop";
import { Media } from "../../../../components/Media";
export const riotProductSkin = (chroma, palette) => css `
  min-height: 640px;
  margin: 0 auto;
  padding: ${chroma.spacers.bladeEdge.topLarge} 0 ${chroma.spacers.bladeEdge.bottomLarge};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  ${chroma.mediaQueries.tabletDown} {
    min-height: 580px;
  }

  ${Backdrop} {
    ${Media} {
      opacity: 0.8;
      background-color: ${palette.underlay};
    }
  }

  .logo {
    object-fit: contain;
    height: auto;
    max-width: 368px;

    ${chroma.mediaQueries.tabletDown} {
      max-width: 340px;
    }

    ${chroma.mediaQueries.mobileDown} {
      max-width: 238px;
    }
  }

  .availability-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${chroma.spacers.variable.m};

    & .badges-container {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      justify-content: center;

      & img {
        min-width: 40px;
        height: 40px;
        flex-shrink: 0;
        flex-grow: 0;
        width: auto;
      }
    }
  }

  ${BladeContent} {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    flex-grow: 1;
    gap: ${chroma.spacers.variable.m};
  }

  .top-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    gap: 32px;
    ${chroma.mediaQueries.tabletDown} {
      gap: 16px;
    }
  }

  ${BladeHeaderSupertitle} {
    text-align: center;
    font-weight: bold;
    color: ${palette.bladetext1};
    ${chroma.typography.body3};
  }

  .availability-title {
    ${chroma.typography.body3};
    font-weight: 700;
    text-align: center;
    max-width: 500px;
  }

  ${CTA} {
    margin-top: 32px;

    ${chroma.mediaQueries.tabletDown} {
      margin-top: 16px;
    }

    padding: 13px 34px;
    font-weight: 700;
    ${chroma.typography.body3};
    ${textUppercaseMixin}
  }
`;
//# sourceMappingURL=index.js.map